module.exports = __webpack_public_path__ + "img/photo-donut-studio.77052fbb.png";